import React from 'react';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { useGitLab } from '../context/GitLabContext';

const Header: React.FC = () => {
  const { user, disconnect } = useGitLab();

  return (
    <header className="app-header flex align-items-center justify-content-between px-4 py-3">
      <div className="flex align-items-center gap-3">
        <i className="pi pi-gitlab text-4xl text-primary"></i>
        <div>
          <h1 className="text-xl font-bold m-0 text-color">Release Creator</h1>
          <span className="text-color-secondary text-sm">Manage GitLab releases with ease</span>
        </div>
      </div>

      <div className="flex align-items-center gap-3">
        {user && (
          <div className="flex align-items-center gap-2">
            <Avatar
              image={user.avatar_url || undefined}
              icon={!user.avatar_url ? 'pi pi-user' : undefined}
              shape="circle"
              size="normal"
              className="user-avatar"
            />
            <div className="hidden md:block">
              <div className="font-semibold text-color">{user.name}</div>
              <div className="text-color-secondary text-sm">@{user.username}</div>
            </div>
          </div>
        )}
        <Button
          icon="pi pi-sign-out"
          className="p-button-text p-button-rounded"
          tooltip="Disconnect"
          tooltipOptions={{ position: 'bottom' }}
          onClick={disconnect}
        />
      </div>
    </header>
  );
};

export default Header;
